/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "next-mdx-import-source-file";
export const frontmatter = undefined;
function _createMdxContent(props) {
  const _components = Object.assign({
    h1: "h1",
    p: "p",
    ul: "ul",
    li: "li"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h1, {
      children: "Prerequisites"
    }), "\n", _jsx(_components.p, {
      children: "WebSemaphore is currently supporting two protocols - HTTPS and Websockets."
    }), "\n", _jsx(_components.p, {
      children: "Since both protocols are technology agnostic, it is possible to use the service with any platform / language combination."
    }), "\n", _jsx(_components.p, {
      children: "That being said, currently the most advanced support is available for TypeScript and for the moment the\ndocumentation will assume some familiarity with TypeScript and Javascript."
    }), "\n", _jsxs(_components.p, {
      children: ["If you need support for other languages/stacks please ", _jsx("a", {
        href: "/contact",
        children: "contact us"
      }), "."]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "This guide assumes basic understanding of concepts such as HTTPS, Websockets, server-based, serverless and distributed systems and some familiarity with\nthe ideas of Event Driven Architectures"
      }), "\n", _jsx(_components.li, {
        children: "We also assume you have access to a development environment that includes a fairly recent combination of nodejs/npm"
      }), "\n", _jsx(_components.li, {
        children: "Some bash and git skills"
      }), "\n", _jsx(_components.li, {
        children: "Public ip / domain is beneficial to use the HTTPs callback functionality, however all concepts can be easily demonstrated using Websockets only."
      }), "\n"]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
